var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.inWhoInSection
        ? _c(
            "div",
            { staticClass: "verticalCenter order-bar" },
            [
              _c("b-form-select", {
                staticClass: "order-by offset-sm-5 custom-select-forum",
                attrs: { options: _vm.sortOptions },
                on: { input: _vm.sortSelect },
                model: {
                  value: _vm.$store.state.forum.searchSort,
                  callback: function($$v) {
                    _vm.$set(_vm.$store.state.forum, "searchSort", $$v)
                  },
                  expression: "$store.state.forum.searchSort"
                }
              })
            ],
            1
          )
        : Object.keys(this.$store.state.forum.activityFilters).length
        ? _c(
            "div",
            [
              _c(
                "base-button",
                { attrs: { white: "" }, on: { click: _vm.resetWhoInFilters } },
                [_vm._v(_vm._s(_vm.$t("resetFilters")))]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.inWhoInSection && _vm.activitySource.length
        ? _c(
            "div",
            _vm._l(_vm.activitySource, function(item) {
              return _c(
                "b-badge",
                {
                  key: item.id,
                  staticClass: "activity-filter-block",
                  class: {
                    "activity-selected":
                      _vm.$store.state.forum.activityFilterSelected === item.id
                  },
                  on: {
                    click: function($event) {
                      return _vm.searchActivity(item.id, item.createdByUser)
                    }
                  }
                },
                [_vm._v(_vm._s(item[_vm.normalizeForumProp("name")]))]
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("forum-article-block", {
        staticStyle: { "min-height": "100vh" },
        attrs: { hideForumDescriptionMobile: "" },
        on: { loadMoreEntries: _vm.loadMoreEntries }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08dea57c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08dea57c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/healthy-community/forum/Forum.vue
// module id = 4164
// module chunks = 9